import { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import Animation from "../assets/Animation.gif";
import warnicon from "../assets/warnorange.png";
import RedAnimation from "../assets/RedAnimation.gif";
import AddNewRpaUser from "./AddNewRpaUser";
import {
  HospitalServices,
  hospitalupdate,
  addUpdateTmsCredential,
} from "../services/HospitalServices";
import "./ManageRpa.scss";
import { Switch, Stack } from "@mui/material";
import editIcon from "../assets/editIcon.svg";
import CustomPagination from "../utils/paginationUtils";
import { RpaServices } from "../services/RpaServices";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Close from "@mui/icons-material/Close";
import UpdateHospitalDetailsModal from "./UpdateHospitalDetailsModal";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
const ManagedRpa = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(null);
  const [hospitalList, setHospitalList] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [rpaLogs, setRpaLogs] = useState([]);
  const [rpaTotalPages, setRpaTotalPages] = useState(1);
  const [hospitalTmsCredentials, setHospitalTmsCredentials] = useState([]);
  const [selectedHospitalTmsUser, setSelectedHospitalTmsUser] = useState(null);
  const [addUserPopVisible, setAddUserPopUpVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const searchTimeRef = useRef(null);
  const limit = 10;
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isLogPopupVisible, setIsLogPopupVisible] = useState(false);
  const [selectedRpaLog, setSelectedRpaLog] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [applicationIds, setApplicationIds] = useState([]);

  // NEW: backend filter state – "all" | "active" | "inactive"
  const [pmjayFilter, setPmjayFilter] = useState("all");

  const handleButtonClick = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const togglePasswordVisibility = (hospitalId) => {
    setIsPasswordVisible((prevId) =>
      prevId === hospitalId ? null : hospitalId,
    );
  };
  const handleSearch = (e) => {
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };

  const fetchHospitalList = async () => {
    setIsLoading(true);
    try {
      // decide what to send to backend:
      // all  -> "" (no filter)
      // active -> true
      // inactive -> false
      let pmjaystatusParam = "";
      if (pmjayFilter === "active") pmjaystatusParam = true;
      if (pmjayFilter === "inactive") pmjaystatusParam = false;

      const res = await HospitalServices.getHospitalUserList(
        searchKey,
        page,
        limit,
        pmjaystatusParam,
      );
      if (res?.data?.userList) {
        setHospitalList(res?.data?.userList);
        setTotalPages(res?.data?.totalPages || 1);
        setTotal(res?.data?.total || 0);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchRpaStatus = async () => {
    try {
      const response = await RpaServices.rpaStatus();

      if (response.status === 200 && response.data?.requests) {
        const requestStatuses = response.data.requests.map(
          (req) => req.requestStatus,
        );

        return requestStatuses;
      } else {
        alert("Failed to fetch RPA Requests. Please try again.");
        return null;
      }
    } catch (error) {
      handleApiErrorResponses(error);
      return null;
    }
  };

  const fetchrpaLogs = async (page, limit, hospitalId) => {
    setIsLoading(true);
    try {
      const res = await RpaServices.manageRpaHospitalLogs(
        page,
        limit,
        hospitalId,
      );
      if (res?.data?.requests) {
        setRpaLogs(res.data.requests);
        setRpaTotalPages(res.data.totalPages || 1);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getApplications = async () => {
      try {
        const response = await RpaServices.manageApplicationId();
        const applications = response.data.applications;
        setApplicationIds(applications);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    };

    getApplications();
  }, []);

  useEffect(() => {
    fetchRpaStatus();
  }, []);

  const handleUpdateTmsCredential = async () => {
    try {
      const res = await addUpdateTmsCredential(hospitalTmsCredentials);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleSaveChanges = async () => {
    if (
      !selectedUser?.hospital?.applicationId ||
      !selectedUser?.hospital?.tmsVersion
    ) {
      alert("Please fill in all the required fields.");
      return;
    }

    const data = {
      fullName: selectedUser?.fullName,
      email: selectedUser?.email,
      phone: selectedUser?.phone,
      hospital: selectedUser?.hospital?.name,
      pmjayPassword: selectedUser?.hospital?.pmjayPassword,
      pmjayUserId: selectedUser?.hospital?.pmjayUserId,
      tmsVersion: selectedUser?.hospital?.tmsVersion,
      applicationId: selectedUser?.hospital?.applicationId,
      rpaStatusL: selectedUser?.hospital?.rpaApplicationStatus,
    };

    try {
      setIsLoading(true);
      const response = await hospitalupdate(selectedUser?.hospital?.id, data);
      await handleUpdateTmsCredential();
      if (response?.status === 200) {
        alert("Changes saved successfully!");
        setIsPopupVisible(false);
        await fetchHospitalList();
      } else {
        alert("Failed to update hospital details.");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleApplicationChange = (e) => {
    const newApplicationId = e.target.value;

    // Ensure selectedUser and hospital exist before updating
    setSelectedUser((prevUser) => {
      if (!prevUser || !prevUser.hospital) return prevUser; // Prevent null updates

      return {
        ...prevUser,
        hospital: {
          ...prevUser.hospital,
          applicationId: newApplicationId, // Update applicationId safely
        },
      };
    });
  };

  const handleStatusChange = async (hospital, status) => {
    const updatedStatus = hospital?.pmjaystatus === true ? false : true;
    const updatedData = {
      userid: hospital.id,
      pmjaystatus: updatedStatus,
    };
    try {
      const response = await HospitalServices.updateUserRpaDetails(updatedData);
      if (response?.status === 200) {
        fetchHospitalList();
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  // refetch when page, search or backend filter changes
  useEffect(() => {
    fetchHospitalList();
  }, [page, searchKey, pmjayFilter]);

  const handleMenuOpen = (event, rpalog) => {
    setAnchorEl(event.currentTarget);
    setSelectedRpaLog(rpalog);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRpaLog(null);
  };

  const handleLog = () => {
    if (selectedRpaLog) {
      setSelectedUser(selectedRpaLog);
      setIsLogPopupVisible(true);
      fetchrpaLogs(1, 20, selectedRpaLog.hospital.id);
    }
    handleMenuClose();
  };

  return (
    <div className="initiateadmission-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp;/ &nbsp;
        Dashboard &nbsp;/ &nbsp; Manage Hospital
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">
          Manage Hospital <span className="ml-1">({total})</span>
        </div>
        <div className="flex gap-3 items-center">
          <div
            style={{ border: "1px solid #E4E4E4" }}
            className="flex gap-2 px-2 py-2 rounded-[8px] "
          >
            <SearchIcon />
            <input
              type="text"
              className="outline-none border-0"
              placeholder="Search Anything"
              onChange={handleSearch}
            />
          </div>

          {/* NEW: backend pmjayStatus filter dropdown */}
          <select
            className="px-3 py-2 rounded-[999px] text-sm border border-[#E4E4E4] bg-white text-[#191919] shadow-sm
             hover:border-[#017C57] focus:border-[#017C57] focus:ring-2 focus:ring-[#017C57]/20
             transition-all duration-150 cursor-pointer"
            value={pmjayFilter}
            onChange={(e) => {
              setPmjayFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value="all">All Hospitals</option>
            <option value="active">Active </option>
            <option value="inactive">Inactive </option>
          </select>
        </div>
      </div>
      <hr style={{ color: "#E7E7E7", marginBottom: "20px" }} />
      <div className="Second-container">
        <div className="flex justify-between">
          {!isLoading ? (
            hospitalList?.length > 0 ? (
              <section className="mt-1">
                <div className="grid grid-cols-8 text-[#191919] font-semibold px-8 py-1 gap-2">
                  <div className="text-[18px] w-2">
                    Sync <br />
                    Status
                  </div>
                  <div className="text-[18px] text-[#191919] font-semibold  ">
                    Hospital Name
                  </div>
                  <div className="text-[18px] ml-[-10px]">Last Request</div>

                  <div className="text-[18px]">Application Id</div>
                  <div className="text-[18px]">Hospital Admin</div>
                  <div className="text-[18px]">Phone Number</div>

                  <div className="text-[18px]">User Details</div>

                  <div className="text-[18px] text-center">Action</div>
                </div>

                {hospitalList.map((hospital, idx) => (
                  <article
                    key={idx}
                    className={`py-6 px-8 rounded-[16px] ${
                      idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                    }`}
                  >
                    <div
                      className={`grid grid-cols-8 text-[#797979] text-[18px] gap-2`}
                    >
                      <div className={`text-[#797979] text-[18px]`}>
                        <img
                          src={
                            !hospital?.pmjaystatus
                              ? RedAnimation
                              : hospital?.hospital?.rpaApplicationStatus ===
                                  "MAPPING PENDING"
                                ? warnicon
                                : hospital?.hospital?.newRpaRequest == 0
                                  ? warnicon
                                  : hospital?.hospital?.rpaApplicationStatus ===
                                      "RUNNING"
                                    ? Animation
                                    : RedAnimation
                          }
                          alt={hospital?.hospital?.rpaApplicationStatus}
                          title={
                            !hospital?.pmjaystatus
                              ? "HOSPITAL INACTIVE"
                              : hospital?.hospital?.rpaApplicationStatus ===
                                  "MAPPING PENDING"
                                ? "MAPPING PENDING"
                                : hospital?.hospital?.newRpaRequest == 0
                                  ? hospital?.hospital?.rpaApplicationStatus +
                                    " | 0 REQUEST"
                                  : hospital?.hospital?.rpaApplicationStatus ===
                                      "RUNNING"
                                    ? "RUNNING" +
                                      " | RPA Request:" +
                                      hospital?.hospital?.newRpaRequest
                                    : "NOT RUNNING"
                          }
                          className="w-6 h-6"
                        />
                      </div>
                      <div className={`text-[#797979] text-[18px]`}>
                        {hospital?.hospital?.name + " " || "--"}
                        {hospital?.hospital?.tmsVersion}
                      </div>

                      <div className="text-[#797979] text-[18px] ml-5">
                        {hospital?.hospital?.latestRequestLog?.lastProcessedAt
                          ? new Date(
                              hospital.hospital.latestRequestLog
                                .lastProcessedAt,
                            ).toLocaleString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: true,
                            })
                          : "NA"}
                      </div>
                      <div className="text-[#797979] text-[18px] ml-8">
                        &nbsp;&nbsp;{hospital?.hospital?.applicationId || "--"}
                        {` ${hospital?.rpaAppliction?.ownerName || ""}`}
                        <br />
                        {hospital?.hospital?.applicationId ? (
                          ""
                        ) : (
                          <span
                            onClick={() => {
                              setSelectedUser(hospital); // Set the selected hospital
                              setIsPopupVisible(true); // Show the popup
                            }}
                            className="text-green-700 cursor-pointer"
                          >
                            {" "}
                            Map
                          </span>
                        )}
                      </div>
                      <div className={`text-[#797979] text-[18px]`}>
                        {hospital?.fullName || "--"}
                      </div>
                      <div className={`text-[#797979] text-[18px]`}>
                        {hospital?.phone || "--"}
                      </div>

                      <div className={` text-[#797979] text-[15px] `}>
                        {hospital?.hospital?.tmsVersion === "2.0" ? (
                          <div>
                            {hospital?.hospital?.hospitaltmscredentials?.map(
                              (cred, idx) => {
                                return <div>{cred.pmjayNumber}</div>;
                              },
                            )}
                          </div>
                        ) : (
                          "--"
                        )}{" "}
                      </div>

                      <div className="flex justify-center items-start">
                        <Stack direction="row" spacing={1} alignItems="center">
                          <span style={{ textTransform: "capitalize" }}>
                            {hospital?.pmjaystatus}
                          </span>
                          <Switch
                            checked={hospital?.pmjaystatus === true}
                            onChange={() => {
                              const newStatus = !hospital?.pmjaystatus;
                              const statusText = newStatus
                                ? "activate"
                                : "deactivate";
                              if (
                                window.confirm(
                                  `Are you sure you want to ${statusText} this hospital?`,
                                )
                              ) {
                                handleStatusChange(hospital, newStatus);
                              }
                            }}
                            inputProps={{ "aria-label": "toggle status" }}
                            style={{
                              color: hospital?.pmjaystatus
                                ? "#017C57"
                                : "#B0B0B0",
                            }}
                            sx={{
                              "& .MuiSwitch-thumb": {
                                backgroundColor: hospital?.pmjaystatus
                                  ? "#017C57"
                                  : "#D3D3D3",
                              },
                              "& .MuiSwitch-track": {
                                backgroundColor: hospital?.pmjaystatus
                                  ? "#017C57"
                                  : "#D3D3D3",
                              },
                            }}
                          />

                          <span>
                            <img
                              src={editIcon}
                              alt="edit-icon"
                              className="w-[18px] cursor-pointer"
                              onClick={() => {
                                setSelectedUser(hospital); // Set the selected hospital
                                setHospitalTmsCredentials(
                                  hospital?.hospital?.hospitaltmscredentials,
                                );
                                setIsPopupVisible(true); // Show the popup
                              }}
                            />
                          </span>

                          <div className="flex justify-center items-center gap-2">
                            <MoreVertIcon
                              onClick={(event) =>
                                handleMenuOpen(event, hospital)
                              }
                              className="cursor-pointer"
                            />
                            <Menu
                              anchorEl={anchorEl}
                              open={Boolean(anchorEl)}
                              onClose={handleMenuClose}
                            >
                              <MenuItem onClick={handleLog}>Log</MenuItem>
                            </Menu>
                          </div>
                        </Stack>
                      </div>
                    </div>
                  </article>
                ))}
              </section>
            ) : (
              <div className="w-full h-full flex justify-center items-center font-semibold text-xl text-[#191919]">
                No Data Found
              </div>
            )
          ) : (
            <div className="w-full h-[500px] flex justify-center items-center">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
      {isPopupVisible && (
        <UpdateHospitalDetailsModal
          selectedUser={selectedUser}
          setSelectedHospitalTmsUser={setSelectedHospitalTmsUser}
          hospitalTmsCredentials={hospitalTmsCredentials}
          setHospitalTmsCredentials={setHospitalTmsCredentials}
          setSelectedUser={setSelectedUser}
          setOpen={setIsPopupVisible}
          setAddUserPopUpVisible={setAddUserPopUpVisible}
          handleSaveChanges={handleSaveChanges}
          isPasswordVisible={isPasswordVisible}
          togglePasswordVisibility={togglePasswordVisibility}
          handleApplicationChange={handleApplicationChange}
          applicationIds={applicationIds}
          fetchHospitalList={fetchHospitalList}
        />
      )}
      {addUserPopVisible && (
        <AddNewRpaUser
          setOpen={setAddUserPopUpVisible}
          selectedUser={selectedUser}
          hospitalTmsCredentials={hospitalTmsCredentials}
          setHospitalTmsCredentials={setHospitalTmsCredentials}
          selectedHospitalTmsUser={selectedHospitalTmsUser}
          setSelectedHospitalTmsUser={setSelectedHospitalTmsUser}
          type={selectedHospitalTmsUser ? "edit" : "add"}
          applicationIds={applicationIds}
        />
      )}
      {isLogPopupVisible && (
        <div className="popup-overlay">
          <div className="popup-container relative max-h-[90%] w-[328px] xl:w-[50%] bg-white rounded-[16px] pb-0 xl:p-0 z-[1200]">
            <div className="absolute right-12 top-8 cursor-pointer">
              <Close
                alt="close-icon"
                onClick={() => {
                  setIsLogPopupVisible(false);
                }}
              />
            </div>

            <div className="space-y-4 p-6">
              <h2 className="text-[#191919] text-[24px] font-semibold">
                Log Details
              </h2>
              <div className="overflow-auto max-h-[480px]">
                {" "}
                {/* Scrollable container */}
                <table className="w-full text-left">
                  <thead>
                    <tr>
                      <th className="text-[#191919] text-[18px] font-semibold p-2 sticky top-0 bg-white">
                        Request ID
                      </th>
                      <th className="text-[#191919] text-[18px] font-semibold p-2 sticky top-0 bg-white">
                        Request Type
                      </th>
                      <th className="text-[#191919] text-[18px] font-semibold p-2 sticky top-0 bg-white">
                        Request By
                      </th>
                      <th className="text-[#191919] text-[18px] font-semibold p-2 sticky top-0 bg-white">
                        Request To (Application ID)
                      </th>
                      {/* Add more headers if needed */}
                    </tr>
                  </thead>
                  <tbody>
                    {rpaLogs.map((log, logIndex) => (
                      <tr key={logIndex} className="border-b border-gray-200">
                        <td className="p-2">{log?.id || "--"}</td>
                        <td className="p-2">
                          {log?.requestType
                            ? log?.requestType?.replace("_", " ")
                            : "-"}
                        </td>
                        <td className="p-2">{log?.hospital?.name || "--"}</td>
                        <td className="p-2">
                          {log?.hospital?.applicationId || "--"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center mt-4">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default ManagedRpa;
